import { LayerTypeGroupId, LayerTypeId, LayerValueType } from "../shared/generated/enums";
import { CroppingStyle } from "../shared/layers/croppingStyle";
import { Datalayer } from "../shared/layers/datalayer";
import { DatalayerFactoryProvider } from "../shared/layers/datalayerFactory";
import { DatalayersMap } from "../shared/layers/datalayersMap";
import { DatalayerZone } from "../shared/layers/datalayerZone";
import { MapDependencies } from "../shared/layers/dependencies";
import { DrawingFeature } from "../shared/layers/drawing/feature";
import { DrawingLayer } from "../shared/layers/drawing/layer";
import { getDrawingFeatureEditStyle, getDrawingLineDefaultDrawingStyle, getDrawingPolygonDefaultDrawingStyle } from "../shared/layers/drawing/styles";
import { LayerViewModel } from "../shared/layers/layerViewModel";
import { createLayerViewModelFactory } from "../shared/layers/layerViewModelFactory";
import { DatalayersApiLoaderProvider, setupLayerRelations, setupLayers } from "../shared/layers/loader";
import { getAllNodes, getFieldsRootNodes, getSingleFieldRootNodes, getTypesRootNodes } from "../shared/layers/menu/nodes";
import { filterLayersForType, flattenTypes, setupTypes } from "../shared/layers/mgr/layerTypes";
import { getTerraMapDynamicColors, getTerraMapDynamicViewerOptions } from "../shared/layers/terramap";
import { getTooltip } from "../shared/layers/tooltip";
import { DefaultLineWidth, LayerEditMode, LinePattern, ThickLineWidth, ZoneTextLocation } from "../shared/layers/types";
import { cloneDatalayerZone, getKeyAsRanges, getLargestZone, getLayerDescription, isMapLayerZone, runOnLayersLoaded, showLayers } from "../shared/layers/utils";
import { setupVariants } from "../shared/layers/variants";
import { DiscreteValuesViewer } from "../shared/layers/viewers/discrete";
import { NumericValuesViewer } from "../shared/layers/viewers/numeric";
import { getRangeFromValue } from "../shared/layers/viewers/range";
import { TerramapDynamicLayerViewer } from "../shared/layers/viewers/terramap";
import { YieldMapViewer } from "../shared/layers/viewers/yield";
import { DatalayerViewManagerProvider } from "../shared/layers/viewManager";

export const menu = {
    getFieldsRootNodes,
    getSingleFieldRootNodes,
    getAllNodes,
    getTypesRootNodes,
}

export const mgr = {
    setupTypes,
    flattenTypes,
    filterLayersForType
}

export const datalayers = {

    Datalayer,
    DatalayerZone,
    DatalayersMap,
    DatalayerFactoryProvider,
    DatalayersApiLoaderProvider,
    DatalayerViewManagerProvider,
    MapDependencies,
    LayerViewModel,

    DrawingFeature,
    DrawingLayer,

    NumericValuesViewer,
    DiscreteValuesViewer,
    TerramapDynamicLayerViewer,
    YieldMapViewer,

    CroppingStyle,

    LayerTypeId,
    LayerTypeGroupId,
    LayerValueType,

    getDrawingFeatureEditStyle,
    getDrawingLineDefaultDrawingStyle,
    getDrawingPolygonDefaultDrawingStyle,
    getKeyAsRanges,
    getLayerDescription,
    getTerraMapDynamicViewerOptions,
    getTooltip,
    runOnLayersLoaded,
    setupLayers,
    setupLayerRelations,
    setupVariants,
    showLayers,
    cloneDatalayerZone,
    isMapLayerZone,
    getLargestZone,
    getRangeFromValue,
    getTerraMapDynamicColors,
    createLayerViewModelFactory,

    LinePattern,
    ZoneTextLocation,
    LayerEditMode,

    DefaultLineWidth,
    ThickLineWidth,

    menu,
    mgr

}